// @ts-nocheck
/**
* ATTENTION!
* @generated THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
*/

import * as Types from '../schema';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client/react';
import * as ApolloReactHooks from '@apollo/client/react';
const defaultOptions = {} as const;
export type AiChatMessagesQueryVariables = Types.Exact<{
  sessionId: Types.Scalars['ID']['input'];
}>;


export type AiChatMessagesQuery = { __typename?: 'Query', aiChatMessages: Array<{ __typename?: 'AiChatMessage', id: string, sessionId: string, role: Types.AiChatMessageRole, content: string, createdAt: any, files: Array<{ __typename?: 'ChatFile', id: string, sessionId: string, messageId?: string | null, origin: Types.ChatFileOrigin, status: Types.ChatFileStatus, fileName: string, mimeType?: string | null, size?: number | null, width?: number | null, height?: number | null, failureCode?: string | null, operationId?: string | null, createdAt: any }>, inputRequest?: { __typename?: 'AiChatInputRequest', id: string, sessionId: string, assistantMessageId: string, status: Types.AiChatInputRequestStatus, questions: Array<{ __typename?: 'AiChatInputQuestion', id: string, heading: string, question: string, selectionMode: Types.AiChatSelectionMode, recommendedOptionId?: string | null, options: Array<{ __typename?: 'AiChatInputOption', id: string, label: string, description?: string | null }> }>, answers: Array<{ __typename?: 'AiChatInputAnswer', questionId: string, selectedOptionIds: Array<string>, customText?: string | null }> } | null, toolCalls: Array<{ __typename?: 'AiChatToolCall', toolName: string, summary: string, recordsRead: number, recordsWritten: number, status: string, errorCode?: string | null, sources: Array<{ __typename?: 'AiChatSource', id: string, title: string, url: string }>, references: Array<{ __typename?: 'AiChatFileReference', kind: Types.AiChatFileReferenceKind, id: string, fileName?: string | null }> }>, usage?: { __typename?: 'AiChatUsage', callsCount: number, estimatedInputTokens: number, estimatedOutputTokens: number, recordsRead: number, recordsWritten: number } | null }> };


export const AiChatMessagesDocument = gql`
    query AiChatMessages($sessionId: ID!) {
  aiChatMessages(sessionId: $sessionId) {
    id
    sessionId
    role
    content
    files {
      id
      sessionId
      messageId
      origin
      status
      fileName
      mimeType
      size
      width
      height
      failureCode
      operationId
      createdAt
    }
    inputRequest {
      id
      sessionId
      assistantMessageId
      status
      questions {
        id
        heading
        question
        selectionMode
        recommendedOptionId
        options {
          id
          label
          description
        }
      }
      answers {
        questionId
        selectedOptionIds
        customText
      }
    }
    toolCalls {
      sources {
        id
        title
        url
      }
      references {
        kind
        id
        fileName
      }
      toolName
      summary
      recordsRead
      recordsWritten
      status
      errorCode
    }
    usage {
      callsCount
      estimatedInputTokens
      estimatedOutputTokens
      recordsRead
      recordsWritten
    }
    createdAt
  }
}
    `;

/**
 * __useAiChatMessagesQuery__
 *
 * To run a query within a React component, call `useAiChatMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiChatMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiChatMessagesQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useAiChatMessagesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AiChatMessagesQuery, AiChatMessagesQueryVariables> & ({ variables: AiChatMessagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AiChatMessagesQuery, AiChatMessagesQueryVariables>(AiChatMessagesDocument, options);
      }
export function useAiChatMessagesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AiChatMessagesQuery, AiChatMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AiChatMessagesQuery, AiChatMessagesQueryVariables>(AiChatMessagesDocument, options);
        }
// @ts-ignore
export function useAiChatMessagesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AiChatMessagesQuery, AiChatMessagesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiChatMessagesQuery, AiChatMessagesQueryVariables>;
export function useAiChatMessagesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiChatMessagesQuery, AiChatMessagesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiChatMessagesQuery | undefined, AiChatMessagesQueryVariables>;
export function useAiChatMessagesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiChatMessagesQuery, AiChatMessagesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AiChatMessagesQuery, AiChatMessagesQueryVariables>(AiChatMessagesDocument, options);
        }
export type AiChatMessagesQueryHookResult = ReturnType<typeof useAiChatMessagesQuery>;
export type AiChatMessagesLazyQueryHookResult = ReturnType<typeof useAiChatMessagesLazyQuery>;
export type AiChatMessagesSuspenseQueryHookResult = ReturnType<typeof useAiChatMessagesSuspenseQuery>;
export type AiChatMessagesQueryResult = ApolloReactCommon.QueryResult<AiChatMessagesQuery, AiChatMessagesQueryVariables>;